module.exports = function (fox) {
	'use strict';
	require('./templates/sestafostaPopup.a.tpl')(fox);
	require('./widget/sestafosta-popup.es.js')(fox);
	require('./widget/confirm-popup.es.js')(fox);
	require('./css/_gui-elem.css');

};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/sesta-fosta/index.js
// module id = 598
// module chunks = 4